module.exports = __webpack_public_path__ + "media/images/top/etc-card-1-4fd7a87934de4732311f7070637ed3bf.jpg";